import axios from 'axios'

// 上传图片
export function uploadItemImg (datas) {
  const url = `/fileUpload/imgUpload`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/public/quill.js